import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonContent, IonIcon, IonItem, IonLabel, IonList, IonListHeader, popoverController } from '@ionic/vue';
import { exitOutline, personCircleOutline } from 'ionicons/icons';
import { translate } from '@/i18n';
import { useAuthStore } from '@/store/auth';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserActionsPopover',
  setup(__props) {

const authStore = useAuthStore();

const redirectToUserDetails = () => {
  window.location.href = `${process.env.VUE_APP_USERS_LOGIN_URL}?oms=${authStore.oms}&token=${authStore.token.value}&expirationTime=${authStore.token.expiration}&partyId=${authStore.current.partyId}`;
  popoverController.dismiss();
};

const logout = async () => {
  await authStore.logout();
  popoverController.dismiss();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonList), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonListHeader), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(authStore).current?.partyName ? _unref(authStore).current.partyName : _unref(authStore).current.userLoginId), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItem), {
            button: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (redirectToUserDetails()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonLabel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("View profile")), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonIcon), { icon: _unref(personCircleOutline) }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItem), {
            button: "",
            lines: "none",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (logout()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonLabel), { color: "danger" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("Logout")), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonIcon), {
                icon: _unref(exitOutline),
                color: "danger"
              }, null, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})